// CORE
export const REQUEST_SEARCH_SERVICE = 'service/REQUEST_SEARCH_SERVICE'
export const SUCCESS_FETCH_SERVICES = 'service/SUCCESS_FETCH_SERVICES'
export const FINISH_FETCH_COMPANY = 'company/FINISH_FETCH_COMPANY'
export const REQUEST_FETCH_COMPANY = 'company/REQUEST_FETCH_COMPANY'
export const REQUEST_UPDATE_COMPANY = 'company/REQUEST_UPDATE_COMPANY'
export const FINISH_UPDATE_COMPANY = 'company/FINISH_UPDATE_COMPANY'
export const RESET_UPDATE_COMPANY_STATUS = 'company/RESET_UPDATE_COMPANY_STATUS'
export const INTERRUPT_LOADING_COMPANY = 'company/INTERRUPT_LOADING_COMPANY'

// FORM
export const REQUEST_FINISH_ALL_FORMS = 'form/REQUEST_SEARCH_FORMS'
export const SUCCESS_FETCH_FORMS = 'form/SUCCESS_FETCH_FORMS'
export const FINISH_FETCH_ALL_FORMS = 'form/FIN_FETCH_ALL'
export const REQUEST_FETCH_FORM = 'form/REQUEST_FETCH'
export const FINISH_FETCH_FORM = 'form/FINISH_FETCH'
export const REQUEST_UPDATE_FORM = 'form/REQUEST_UPDATE'
export const FINISH_UPDATE_FORM = 'form/FINISH_UPDATE'
export const UNLOAD_FORM = 'form/UNLOAD_FORM'
export const REQUEST_DELETE_FORM = 'form/REQUEST_DELETE_FORM'
export const FINISH_DELETE_FORM = 'form/FINISH_DELETE_FORM'
export const REQUEST_SEARCH_EXTERNALURLS = 'form/REQUEST_SEARCH_EXTERNALURLS'
export const FINISH_SEARCH_EXTERNALURLS = 'form/FINISH_SEARCH_EXTERNALURLS'
export const REQUEST_UPDATE_EXTERNALURLS = 'form/REQUEST_UPDATE_EXTERNALURLS'
export const FINISH_UPDATE_EXTERNALURLS = 'form/FINISH_UPDATE_EXTERNALURLS'
export const UNLOAD_EXTERNALURLS = 'form/UNLOAD_EXTERNALURLS'
export const REQUEST_SEARCH_CLIENTRECAPTCHA =
  'form/REQUEST_SEARCH_CLIENTRECAPTCHA'
export const FINISH_SEARCH_CLIENTRECAPTCHA =
  'form/FINISH_SEARCH_CLIENTRECAPTCHA'
export const REQUEST_UPDATE_CLIENTRECAPTCHA =
  'form/REQUEST_UPDATE_CLIENTRECAPTCHA'
export const FINISH_UPDATE_CLIENTRECAPTCHA =
  'form/FINISH_UPDATE_CLIENTRECAPTCHA'
export const REQUEST_FETCH_FORM_USER = 'form/REQUEST_FETCH_FORM_USER'
export const FINISH_FETCH_FORM_USER = 'form/FINISH_FETCH_FORM_USER'
export const CLEAR_FETCH_FORM_USER = 'form/CLEAR_FETCH_FORM_USER'
export const ADD_FORM_USER = 'form/ADD_FORM_USER'
export const FIX_FORM_USER_MAIL = 'form/FIX_FORM_USER_MAIL'
export const DELETE_FORM_INPUT = 'form/DELETE_FORM_INPUT'
export const DELETE_FORM_USER = 'form/DELETE_FORM_USER'
export const CHANGE_FORM_USER_CHECK = 'form/CHANGE_FORM_USER_CHECK'

// セッション
export const USER_SETTING = 'login/USER_SETTING'
export const REQ_LOGIN = 'login/REQ_LOGIN'
export const FAILURE_LOGIN = 'login/FAILURE_LOGIN'
export const SUCCESS_LOGIN = 'login/SUCCESS_LOGIN'
export const LOGOUT = 'LOGOUT'
export const TOGGLE_SIDEMENU = 'TOGGLE_SIDEMENU'
// 起動
export const START_INITIALIZE = 'boot/START_INITIALIZE'
export const FINISH_INITIALIZE = 'boot/FINISH_INITIALIZE'
export const LOADED_INITIAL_VALUES = 'boot/LOADED_INITIAL_VALUES'

// SITE起動
export const LOADED_INITIAL_SITE_VALUES = 'boot/LOADED_INITIAL_SITE_VALUES'

// 投稿
export const REQUEST_SHOW_POST_LIST = 'post/REQUEST_SHOW_POST_LIST'
export const REQUEST_CHANGE_CONDITION_POST = 'post/CHANGE_CONDITION'
export const SUCCESS_SHOW_POST_LIST = 'post/SUCCESS_SHOW_POST_LIST'
export const FAILURE_SHOW_POST_LIST = 'post/FAILURE_SHOW_POST_LIST'
export const SHOW_POST_ADD_FORM = 'post/SHOW_POST_ADD_FORM'
export const REQUEST_SHOW_POST_FORM = 'post/REQUEST_SHOW_POST_FORM'
export const SUCCESS_SHOW_POST_FORM = 'post/SUCCESS_SHOW_POST_FORM'
export const FAILURE_SHOW_POST_FORM = 'post/FAILURE_SHOW_POST_FORM'
export const REQUEST_SAVE_POST = 'post/REQUEST_SAVE_POST'
export const SUCCESS_CREATE_POST = 'post/SUCCESS_CREATE_POST'
export const RESET_SAVE_POST_STATUS = 'post/RESET_SAVE_POST_STATUS'
export const FAILURE_CREATE_POST = 'post/FAILURE_CREATE_POST'
export const UNLOAD_EDITINT_POST = 'post/UNLOAD_EDITINT_POST'
export const SELECT_FIELDGROUP = 'post/SELECT_FIELDGROUP'
export const SELECT_MAX_SLUG = 'post/SSELECT_MAX_SLUG'
export const SELECT_POST_TYPE = 'post/SELECT_POST_TYPE'
export const REQUEST_DELETE_POST = 'post/REQUEST_DELETE_POST'
export const FINISH_DELETE_POST = 'post/FINISH_DELETE_POST'
export const REQUEST_VIEW_POST = 'post/REQUEST_VIEW_POST'
export const FINISH_VIEW_POST = 'post/FINISH_VIEW_POST'
export const REQUEST_PREVIEW_POST = 'post/REQUEST_PREVIEW_POST'
export const FINISH_PREVIEW_POST = 'post/FINISH_PREVIEW_POST'
export const REQUEST_DUPLICATE_POST = 'post/REQUEST_DUPLICATE_POST'
export const FINISH_DUPLICATE_POST = 'post/FINISH_DUPLICATE_POST'
export const REQUEST_CHANGE_FILTER_POST = 'post/REQUEST_CHANGE_FILTER_POST'
export const LOAD_POST_TERM_LIST = 'post/LOAD_POST_TERM_LIST'
export const REQUEST_CHANGE_FILTER_STATUS = 'post/REQUEST_CHANGE_FILTER_STATUS'
export const RESET_TERMS_POST = 'post/RESET_TERMS_POST'
export const UNLOAD_CURRENT_POST_TYPE = 'post/UNLOAD_CURRENT_POST_TYPE'
export const REQUEST_FETCH_DEFAULT_RELATED_POST_CONDITIONS =
  'post/REQUEST_FETCH_DEFAULT_RELATED_POST_CONDITIONS'
export const FINISH_FETCH_DEFAULT_RELATED_POST_CONDITIONS =
  'post/FINISH_FETCH_DEFAULT_RELATED_POST_CONDITIONS'
export const FAILURE_FETCH_DEFAULT_RELATED_POST_CONDITIONS =
  'post/FAILURE_FETCH_DEFAULT_RELATED_POST_CONDITIONS'
export const UNLOAD_DEFAULT_RELATED_POST_CONDITIONS =
  'post/UNLOAD_DEFAULT_RELATED_POST_CONDITIONS'
export const REQUEST_FETCH_CUSTOM_RELATED_POST_CONDITIONS =
  'post/REQUEST_FETCH_CUSTOM_RELATED_POST_CONDITIONS'
export const FINISH_FETCH_CUSTOM_RELATED_POST_CONDITIONS =
  'post/FINISH_FETCH_CUSTOM_RELATED_POST_CONDITIONS'
export const UNLOAD_CUSTOM_RELATED_POST_CONDITIONS =
  'post/UNLOAD_CUSTOM_RELATED_POST_CONDITIONS'
export const FAILURE_FETCH_CUSTOM_RELATED_POST_CONDITIONS =
  'post/FAILURE_FETCH_CUSTOM_RELATED_POST_CONDITIONS'
export const REQUEST_SAVE_RELATED_POST_CONDITIONS =
  'post/REQUEST_SAVE_RELATED_POST_CONDITIONS'
export const FINISH_SAVE_RELATED_POST_CONDITIONS =
  'post/FINISH_SAVE_RELATED_POST_CONDITIONS'
export const FAILURE_SAVE_RELATED_POST_CONDITIONS =
  'post/FAILURE_SAVE_RELATED_POST_CONDITIONS'
export const REQUEST_SHOW_POST_LIST_IN_SETTING =
  'post/REQUEST_SHOW_POST_LIST_IN_SETTING'
export const SUCCESS_SHOW_POST_LIST_IN_SETTING =
  'post/SUCCESS_SHOW_POST_LIST_IN_SETTING'
export const FAILURE_SHOW_POST_LIST_IN_SETTING =
  'post/FAILURE_SHOW_POST_LIST_IN_SETTING'
export const UNLOAD_POST_LIST_IN_SETTING = 'post/UNLOAD_POST_LIST_IN_SETTING'
export const CLEAR_POST_LIST_IN_SETTING = 'post/CLEAR_POST_LIST_IN_SETTING'

// プロパティ
export const REQUEST_SHOW_PROPERTY_LIST = 'property/REQUEST_SHOW_PROPERTY_LIST'
export const SUCCESS_SHOW_PROPERTY_LIST = 'property/SUCCESS_SHOW_PROPERTY_LIST'
export const CHANGE_PROPERTY_CONDITION = 'property/CHANGE_PROPERTY_CONDITION'
export const REQUEST_SHOW_PROPERTY = 'property/REQUEST_SHOW_PROPERTY'
export const SUCCESS_SHOW_PROPERTY = 'property/SUCCESS_SHOW_PROPERTY'
export const FAILURE_SHOW_PROPERTY = 'property/FAILURE_SHOW_PROPERTY'
export const UNLOAD_PROPERTY = 'property/UNLOAD_PROPERTY'
export const UNLOAD_PROPERTY_LIST = 'property/UNLOAD_PROPERTY_LIST'
export const CHANGE_PROPERTY_PAGINATION = 'property/CHANGE_PROPERTY_PAGINATION'
export const FAILURE_SHOW_PROPERTY_LIST = 'property/FAILURE_SHOW_PROPERTY_LIST'
export const REQUEST_UPDATE_PROPERTY = 'property/REQUEST_UPDATE_PROPERTY'
export const SUCCESS_UPDATE_PROPERTY = 'property/SUCCESS_UPDATE_PROPERTY'
export const FAILURE_UPDATE_PROPERTY = 'property/FAILURE_UPDATE_PROPERTY'
export const REQUEST_CREATE_PROPERTY = 'property/REQUEST_CREATE_PROPERTY'
export const SUCCESS_CREATE_PROPERTY = 'property/SUCCESS_CREATE_PROPERTY'
export const FAILURE_CREATE_PROPERTY = 'property/FAILURE_CREATE_PROPERTY'
export const REQUEST_DELETE_PROPERTY = 'property/REQUEST_DELETE_PROPERTY'
export const SUCCESS_DELETE_PROPERTY = 'property/SUCCESS_DELETE_PROPERTY'
export const FAILURE_DELETE_PROPERTY = 'property/FAILURE_DELETE_PROPERTY'
export const LOCAL_UPDATE_PROPERTY_LIST = 'property/LOCAL_UPDATE_PROPERTY_LIST'

// サイト
export const REQUEST_FETCH_SITE = 'site/REQUEST_FETCH_SITE'
export const FINISH_FETCH_SITE = 'site/FINISH_FETCH_SITE'
export const REQUEST_UPDATE_SITE = 'site/REQUEST_UPDATE_SITE'
export const REQUEST_UPDATE_SITE_PROPERTY = 'site/REQUEST_UPDATE_SITE_PROPERTY'
export const FINISH_UPDATE_SITE = 'site/FINISH_UPDATE_SITE'
export const FINISH_UPDATE_SITE_PROPERTY = 'site/FINISH_UPDATE_SITE_PROPERTY'
export const RESET_UPDATE_SITE_STATUS = 'site/RESET_UPDATE_SITE_STATUS'
export const SELECT_SITE = 'site/SELECT_SITE'
export const FINISH_FETCH_APP_SITE = 'site/FINISH_FETCH_APP_SITE'

// 通知
export const REQUEST_FETCH_ALL_NOTIFICATION = 'notification/REQ_FETCH_ALL'
export const FINISH_FETCH_ALL_NOTIFICATION = 'notification/FIN_FETCH_ALL'

// プロフィール
export const REQUEST_FETCH_PROFILE = 'profile/REQUEST_FETCH_PROFLIE'
export const FINISH_FETCH_PROFILE = 'profile/FINISH_FETCH_PROFILE'
export const REQUEST_UPDATE_PROFILE = 'profile/REQUEST_UPDATE_PROFILE'
export const FINISH_UPDATE_PROFILE = 'profile/FINISH_UPDATE_PROFILE'
export const RESET_UPDATE_PROFILE_STATUS = 'profile/RESET_UPDATE_PROFILE_STATUS'
export const INTERRUPT_LOADING = 'profile/INTERRUPT_LOADING'
export const REQUEST_UPDATE_PROFILE_EMAIL =
  'profile/REQUEST_UPDATE_PROFILE_EMAIL'

// 資料管理
export const REQUEST_FETCH_DOCUMENTS = 'documents/REQUEST_FETCH_DOCUMENTS'
export const FINISH_FETCH_DOCUMENTS = 'documents/FINISH_FETCH_DOCUMENTS'
export const REQUEST_FETCH_DOCUMENT_ID = 'documents/REQUEST_FETCH_DOCUMENT_ID'
export const FINISH_FETCH_DOCUMENT_ID = 'documents/FINISH_FETCH_DOCUMENT_ID'
export const CHANGE_SIDE_MENU = 'boot/CHANGE_SIDE_MENU'
export const REQUEST_UPLOAD_DOCUMENT = 'documents/REQUEST_UPLOAD_DOCUMENT'
export const RECEIVE_DOCUMENT_ERROR = 'documents/RECEIVE_DOCUMENT_ERROR'
export const FINISH_UPLOAD_DOCUMENT = 'documents/FINISH_UPLOAD_DOCUMENT'
export const REQUEST_UPLOAD_FILE = 'documents/REQUEST_UPLOAD_FILE'
export const FINISH_UPLOAD_FILE = 'documents/FINISH_UPLOAD_FILE'
export const RESET_UPLOAD_FILE_STATUS = 'documents/RESET_UPLOAD_FILE_STATUS'
export const REQUEST_DOWNLOAD_DOCUMENT = 'documents/REQUEST_DOWNLOAD_DOCUMENT'
export const REQUEST_DELETE_DOCUMENT = 'documents/REQUEST_DELETE_DOCUMENT'
export const FINISH_DELETE_DOCUMENT = 'documents/FINISH_DELETE_DOCUMENT'
export const FINISH_FETCH_ALL_DOCUMENT = 'documents/FINISH_FETCH_ALL_DOCUMENT'
export const REQUEST_FETCH_SEARCH_DOCUMENT =
  'documents/REQUEST_FETCH_SEARCH_DOCUMENT'
export const FINISH_FETCH_SEARCH_DOCUMENT =
  'documents/FINISH_FETCH_SEARCH_DOCUMENT'
export const CLEAR_SEARCH_DOCUMENT = 'documents/CLEAR_SEARCH_DOCUMENT'
export const REQUEST_CHANGE_CONDITION_DOCUMENT =
  'documents/REQUEST_CHANGE_CONDITION_DOCUMENT'

// そのた
export const SHOW_NOTFOUND = 'misc/SHOW_NOTFOUND'

// プロフィール
export const LOAD_PROFILE = 'profile/LOAD_PROFILE'
export const FINISH_PROFILE = 'profile/FINISH_PROFILE'

// サイドメニュー
export const OPEN_SIDE_MENU = 'sidemenu/open'

// 分類
export const LOADED_ALL_TAXONOMIES = 'taxonomy/LOADED_ALL_TAXONOMIES'
export const REQUEST_SEARCH_TAXONOMY = 'taxonomy/REQUEST_SEARCH_TAXONOMY'
export const FINISH_SEARCH_TAXONOMY = 'taxonomy/FINISH_SEARCH_TAXONOMY'
export const UNLOAD_TERM = 'term/UNLOAD_TERM'
export const REQUEST_FIND_TERM = 'taxonomy/REQUEST_FIND_TERM'
export const FINISH_FIND_TERM = 'taxonomy/FINISH_FIND_TERM'
export const REQUEST_CREATE_TERM = 'taxonomy/REQUEST_CREATE_TERM'
export const FINISH_CREATE_TERM = 'taxonomy/FINISH_CREATE_TERM'
export const REQUEST_UPDATE_TERM = 'taxonomy/REQUEST_UPDATE_TERM'
export const FINISH_UPDATE_TERM = 'taxonomy/FINISH_UPDATE_TERM'
export const REQUEST_DELETE_TERM = 'taxonomy/REQUEST_DELETE_TERM'
export const FINISH_DELETE_TERM = 'taxonomy/FINISH_DELETE_TERM'
export const REQUEST_CHANGE_CONDITION_TERMS = 'taxonomy/CHANGE_CONDITION'
export const REQUEST_SORT_TERM = 'taxonomy/REQUEST_SORT_TERM'
export const FINISH_SORT_TERM = 'taxonomy/FINISH_SORT_TERM'

// ユーザー
export const REQUEST_SEARCH_USER = 'users/REQUEST_SEARCH_USER'
export const FINISH_SEARCH_USER = 'users/FINISH_SEARCH_USER'
export const UNLOAD_USER = 'users/UNLOAD_USER'
export const REQUEST_FIND_USER = 'users/REQUEST_FIND_USER'
export const FINISH_FIND_USER = 'users/FINISH_FIND_USER'
export const REQUEST_UPDATE_USER = 'users/REQUEST_UPDATE_USER'
export const FINISH_UPDATE_USER = 'users/FINISH_UPDATE_USER'

// 見込み客
export const REQUEST_SEARCH_LEAD = 'leads/REQUEST_SEARCH_LEAD'
export const FINISH_SEARCH_LEAD = 'leads/FINISH_SEARCH_LEAD'
export const UNLOAD_LEAD = 'leads/UNLOAD_LEAD'
export const REQUEST_FIND_LEAD = 'leads/REQUEST_FIND_LEAD'
export const FINISH_FIND_LEAD = 'leads/FINISH_FIND_LEAD'
export const REQUEST_UPDATE_LEAD = 'leads/REQUEST_UPDATE_LEAD'
export const FINISH_UPDATE_LEAD = 'leads/FINISH_UPDATE_LEAD'
export const REQUEST_SEARCH_LEAD_ACTION = 'leads/REQUEST_SEARCH_LEAD_ACTION'
export const FINISH_SEARCH_LEAD_ACTION = 'leads/FINISH_SEARCH_LEAD_ACTION'
export const REQUEST_CSV_DOWNLOAD_LEAD = 'leads/REQUEST_CSV_DOWNLOAD_LEAD'
export const FINISH_CSV_DOWNLOAD_LEAD = 'leads/FINISH_CSV_DOWNLOAD_LEAD'
export const REQUEST_CHANGE_CONDITION_LEAD =
  'leads/REQUEST_CHANGE_CONDITION_LEAD'
export const REQUEST_ADD_LEAD_ACTION = 'leads/REQUEST_ADD_LEAD_ACTION'
export const FINISH_ADD_LEAD_ACTION = 'leads/FINISH_ADD_LEAD_ACTION'
export const REQUEST_DESTROY_LEAD = 'leads/REQUEST_DESTROY_LEAD'
export const FINISH_DESTROY_LEAD = 'leads/FINISH_DESTROY_LEAD'
export const REQUEST_ARCHIVE_LEAD = 'leads/REQUEST_ARCHIVE_LEAD'
export const FINISH_ARCHIVE_LEAD = 'leads/FINISH_ARCHIVE_LEAD'
export const REQUEST_UNARCHIVE_LEAD = 'leads/REQUEST_UNARCHIVE_LEAD'
export const FINISH_UNARCHIVE_LEAD = 'leads/FINISH_UNARCHIVE_LEAD'
export const FINISH_ADD_COMMENT = 'leads/FINISH_ADD_COMMENT'
export const REQUEST_DELETE_COMMENT = 'leads/REQUEST_DELETE_COMMENT'
export const FINISH_DELETE_COMMENT = 'leads/FINISH_DELETE_COMMENT'
export const FAILED_DELETE_COMMENT = 'leads/FAILED_DELETE_COMMENT'
export const FINISH_UPDATE_COMMENT = 'leads/FINISH_UPDATE_COMMENT'
export const FINISH_FETCH_ADMINS = 'leads/FINISH_FETCH_ADMINS'
export const REQUEST_FIND_LEAD_ACTION = 'leads/REQUEST_FIND_LEAD_ACTION'
export const FINISH_FIND_LEAD_ACTION = 'leads/FINISH_FIND_LEAD_ACTION'
export const REQUEST_IMPORT_LEAD = 'leads/REQUEST_IMPORT_LEAD'
export const FINISH_IMPORT_LEAD = 'leads/FINISH_IMPORT_LEAD'
export const REQUEST_CSV_HISTORY = 'leads/REQUEST_CSV_HISTORY'
export const FINISH_CSV_HISTORY = 'leads/FINISH_CSV_HISTORY'
export const REQUEST_STORE_LEAD = 'leads/REQUEST_STORE_LEAD'
export const FINISH_STORE_LEAD = 'leads/FINISH_STORE_LEAD'
export const REQUEST_FAILED_CSV_DOWNLOAD = 'leads/REQUEST_FAILED_CSV_DOWNLOAD'
export const FINISH_FAILED_CSV_DOWNLOAD = 'leads/FINISH_FAILED_CSV_DOWNLOAD'
export const REQUEST_UPDATE_LEAD_ACTION = 'leads/REQUEST_UPDATE_LEAD_ACTION'
export const FINISH_UPDATE_LEAD_ACTION = 'leads/FINISH_UPDATE_LEAD_ACTION'
export const REQUEST_DELETE_LEAD_ACTION = 'leads/REQUEST_DELETE_LEAD_ACTION'
export const FINISH_DELETE_LEAD_ACTION = 'leads/FINISH_DELETE_LEAD_ACTION'
export const REQUEST_LEAD_ACTION_SUMMARY_DOCUMENT =
  'leads/REQUEST_LEAD_ACTION_SUMMARY_DOCUMENT'
export const FINISH_LEAD_ACTION_SUMMARY_DOCUMENT =
  'leads/FINISH_LEAD_ACTION_SUMMARY_DOCUMENT'
export const REQUEST_BULK_UPDATE_LEAD = 'leads/REQUEST_BULK_UPDATE_LEAD'
export const FINISH_BULK_UPDATE_LEAD = 'leads/FINISH_BULK_UPDATE_LEAD'
export const REQUEST_BULK_DELETE_LEAD = 'leads/REQUEST_BULK_DELETE_LEAD'
export const FINISH_BULK_DELETE_LEAD = 'leads/FINISH_BULK_DELETE_LEAD'
export const FINISH_LEAD_LOAD = 'leads/FINISH_LEAD_LOAD'

// リスト
export const REQUEST_SEARCH_LEAD_FOR_LIST = 'lists/REQUEST_SEARCH_LEAD_FOR_LIST'
export const FINISH_SEARCH_LEAD_FOR_LIST = 'lists/FINISH_SEARCH_LEAD_FOR_LIST'
export const REQUEST_GET_LISTS = 'lists/REQUEST_GET_LISTS'
export const FINISH_GET_LISTS = 'lists/FINISH_GET_LISTS'
export const REQUEST_FIND_LIST = 'lists/REQUEST_FIND_LIST'
export const FINISH_FIND_LIST = 'lists/FINISH_FIND_LIST'
export const REQUEST_CSV_DOWNLOAD_LIST = 'lists/REQUEST_CSV_DOWNLOAD_LIST'
export const FINISH_CSV_DOWNLOAD_LIST = 'lists/FINISH_CSV_DOWNLOAD_LIST'
export const FINISH_LIST_LOAD = 'lists/FINISH_LIST_LOAD'

// テーマ
export const REQUEST_FETCH_ALL_THEME = 'theme/REQ_FETCH_ALL'
export const FINISH_FETCH_ALL_THEME = 'theme/FIN_FETCH_ALL'
export const REQUEST_FETCH_THEME = 'theme/REQUEST_FETCH'
export const FINISH_FETCH_THEME = 'theme/FINISH_FETCH'
export const REQUEST_UPDATE_THEME = 'theme/REQUEST_UPDATE'
export const FINISH_UPDATE_THEME = 'theme/FINISH_UPDATE'
export const UNLOAD_THEME = 'theme/UNLOAD_THEME'
export const REQUEST_DELETE_THEME = 'theme/REQUEST_DELETE_THEME'
export const FINISH_DELETE_THEME = 'theme/FINISH_DELETE_THEME'
export const RECEIVE_THEME_ERROR = 'theme/RECEIVE_THEME_ERROR'

export const REQUEST_FETCH_ALL_IMPORT_ARTICLES = 'import_articles/REQ_FETCH_ALL'
export const FINISH_FETCH_ALL_IMPORT_ARTICLES = 'import_articles/FIN_FETCH_ALL'

// ページ
export const REQUEST_FETCH_ALL_PAGE = 'page/REQ_FETCH_ALL'
export const FINISH_FETCH_ALL_PAGE = 'page/FIN_FETCH_ALL'
export const REQUEST_CHANGE_CONDITION_PAGE = 'page/CHANGE_CONDITION'
export const REQUEST_FETCH_PAGE = 'page/REQUEST_FETCH'
export const FINISH_FETCH_PAGE = 'page/FINISH_FETCH'
export const REQUEST_UPDATE_PAGE = 'page/REQUEST_UPDATE'
export const RESET_UPDATE_PAGE = 'page/RESET_UPDATE_PAGE'
export const REQUEST_PREVIEW_PAGE = 'page/REQUEST_PREVIEW_PAGE'
export const RESET_PREVIEW_PAGE = 'page/RESET_PREVIEW_PAGE'
export const FINISH_UPDATE_PAGE = 'page/FINISH_UPDATE'
export const UNLOAD_PAGE = 'page/UNLOAD_PAGE'
export const REQUEST_DELETE_PAGE = 'page/REQUEST_DELETE_PAGE'
export const FINISH_DELETE_PAGE = 'page/FINISH_DELETE_PAGE'
export const REQUEST_DUPLICATE_PAGE = 'page/REQUEST_DUPLICATE_PAGE'
export const FINISH_DUPLICATE_PAGE = 'page/FINISH_DUPLICATE_PAGE'
export const UPDATE_SECTION_VALUE = 'page/UPDATE_SECTION_VALUE'
export const ADD_SECTIONS = 'page/ADD_SECTIONS'
export const DELETE_SECTIONS = 'page/DELETE_SECTIONS'
export const UPDATE_SECTIONS = 'page/UPDATE_SECTIONS'
export const GET_SECTIONS_INDEX = 'page/GET_SECTIONS_INDEX'
export const GET_EDIT_FLAG = 'page/GET_EDIT_FLAG'
export const RESET_EDIT_FLAG = 'page/RESET_EDIT_FLAG'
export const GET_ID_INPUT_VALUE = 'page/GET_ID_INPUT_VALUE'
export const RESET_ID_INPUT_VALUE = 'page/RESET_ID_INPUT_VALUE'
export const SET_ID_INPUT_VALUE = 'page/SET_ID_INPUT_VALUE'
export const COPY_SECTION_TO_SECTION_LIST = 'page/COPY_SECTION_TO_SECTION_LIST'
export const ADD_SECTION_TO_SECTION_LIST = 'page/ADD_SECTION_TO_SECTION_LIST'
export const DELETE_SECTION_FROM_SECTION_LIST =
  'page/DELETE_SECTION_FROM_SECTION_LIST'
export const SET_SECTION_LIST_NAME = 'page/SET_SECTION_LIST_NAME'
export const UPDATE_SECTION_LIST_VALUE = 'page/UPDATE_SECTION_LIST_VALUE'
export const GET_SECTION_LIST_INDEX = 'page/GET_SECTION_LIST_INDEX'
export const ON_SELECTED_HEADER = 'page/ON_SELECTED_HEADER'
export const ON_SELECTED_FOOTER = 'page/ON_SELECTED_FOOTER'
export const TOGGLE_PAGE_STATUS = 'page/TOGGLE_PAGE_STATUS'
export const CHANGE_ORIGINAL_TO_COMMON = 'page/CHANGE_ORIGINAL_TO_COMMON'
export const GET_ALERT_FLAG = 'page/GET_ALERT_FLAG'
export const RESET_ALERT_FLAG = 'page/RESET_ALERT_FLAG'
export const REQUEST_FETCH_PAGE_LAYOUTS = 'page/REQUEST_FETCH_PAGE_LAYOUTS'
export const FINISH_FETCH_PAGE_LAYOUTS = 'page/FINISH_FETCH_PAGE_LAYOUTS'
export const FAIL_FETCH_PAGE_LAYOUTS = 'page/FAIL_FETCH_PAGE_LAYOUTS'
export const REQUEST_FETCH_PAGE_LAYOUT_TEMPLATE =
  'page/REQUEST_FETCH_PAGE_LAYOUT_TEMPLATE'
export const FINISH_FETCH_PAGE_LAYOUT_TEMPLATE =
  'page/FINISH_FETCH_PAGE_LAYOUT_TEMPLATE'
export const FAIL_FETCH_PAGE_LAYOUT_TEMPLATE =
  'page/FAIL_FETCH_PAGE_LAYOUT_TEMPLATE'
export const REQUEST_CREATE_PAGE_LAYOUT = 'page/REQUEST_CREATE_PAGE_LAYOUT'
export const FINISH_CREATE_PAGE_LAYOUT = 'page/FINISH_CREATE_PAGE_LAYOUT'
export const SET_PAGE_COLOR_SET_ID = 'page/SET_PAGE_COLOR_SET_ID'
export const SET_PAGE_FONT_ID = 'page/SET_PAGE_FONT_ID'
export const SET_PAGE_SHAPE_MODE = 'page/SET_PAGE_SHAPE_MODE'
export const FETCH_ALL_POST_TYPES = 'page/FETCH_ALL_POST_TYPES'
export const FETCH_ALL_TAXONOMIES = 'page/FETCH_ALL_TAXONOMIES'
export const FETCH_ALL_FILTERED_POSTS = 'page/FETCH_ALL_FILTERED_POSTS'
export const FETCH_ALL_CUSTOM_POSTS = 'page/FETCH_ALL_CUSTOM_POSTS'
export const CHANGE_MOBILE_VIEW_MODE = 'page/CHANGE_MOBILE_VIEW_MODE'
export const RESET_MOBILE_VIEW_MODE = 'page/RESET_MOBILE_VIEW_MODE'

// 動的ページ
export const REQUEST_FETCH_ALL_DYNAMIC_PAGE = 'dynamic_page/REQ_FETCH_ALL'
export const FINISH_FETCH_ALL_DYNAMIC_PAGE = 'dynamic_page/FIN_FETCH_ALL'
export const REQUEST_FETCH_DYNAMIC_PAGE = 'dynamic_page/REQUEST_FETCH'
export const FINISH_FETCH_DYNAMIC_PAGE = 'dynamic_page/FINISH_FETCH'
export const REQUEST_UPDATE_DYNAMIC_PAGE = 'dynamic_page/REQUEST_UPDATE'
export const FINISH_UPDATE_DYNAMIC_PAGE = 'dynamic_page/FINISH_UPDATE'
export const UNLOAD_DYNAMIC_PAGE = 'dynamic_page/UNLOAD_DYNAMIC_PAGE'
export const FAILURE_FETCH_ALL_DYNAMIC_PAGE = 'dynamic_page/FAILURE_FETCH_ALL'
export const FAILURE_FETCH_DYNAMIC_PAGE = 'dynamic_page/FAILURE_FETCH'
export const FAILURE_UPDATE_DYNAMIC_PAGE = 'dynamic_page/FAILURE_UPDATE'

// リダイレクト設定
export const REQUEST_FETCH_ALL_REDIRECTION = 'redirection/REQ_FETCH_ALL'
export const FINISH_FETCH_ALL_REDIRECTION = 'redirection/FIN_FETCH_ALL'
export const REQUEST_FETCH_REDIRECTION = 'redirection/REQUEST_FETCH'
export const FINISH_FETCH_REDIRECTION = 'redirection/FINISH_FETCH'
export const REQUEST_UPDATE_REDIRECTION = 'redirection/REQUEST_UPDATE'
export const FINISH_UPDATE_REDIRECTION = 'redirection/FINISH_UPDATE'
export const UNLOAD_REDIRECTION = 'redirection/UNLOAD_REDIRECTION'
export const REQUEST_DELETE_REDIRECTION =
  'redirection/REQUEST_DELETE_REDIRECTION'
export const FINISH_DELETE_REDIRECTION = 'redirection/FINISH_DELETE_REDIRECTION'

// RSS設定
export const REQUEST_FETCH_RSS = 'rss/REQUEST_FETCH_RSS'
export const FINISH_FETCH_RSS = 'rss/FINISH_FETCH_RSS'
export const REQUEST_UPDATE_RSS = 'rss/REQUEST_UPDATE_RSS'
export const FINISH_UPDATE_RSS = 'rss/FINISH_UPDATE_RSS'
export const RESET_UPDATE_RSS = 'rss/RESET_UPDATE_RSS'
export const INTERRUPT_LOADING_RSS = 'rss/INTERRUPT_LOADING_RSS'
export const UNLOAD_RSS = 'rss/UNLOAD_RSS'

// COOKIE設定
export const REQUEST_FETCH_COOKIE = 'cookie/REQUEST_FETCH_COOKIE'
export const FINISH_FETCH_COOKIE = 'cookie/FINISH_FETCH_COOKIE'
export const REQUEST_UPDATE_COOKIE = 'cookie/REQUEST_UPDATE_COOKIE'
export const FINISH_UPDATE_COOKIE = 'cookie/FINISH_UPDATE_COOKIE'
export const RESET_UPDATE_COOKIE = 'cookie/RESET_UPDATE_COOKIE'
export const INTERRUPT_LOADING_COOKIE = 'cookie/INTERRUPT_LOADING_COOKIE'
export const UNLOAD_COOKIE = 'cookie/UNLOAD_COOKIE'

//ダッシュボード
export const GET_DOCUMENT_LIST = 'dashboard/GET_DOCUMENT_LIST'
export const SERVICE_LOAD = 'dashboard/SERVICE_LOAD'
export const GET_POST_INFO = 'dashboard/GET_POST_INFO'
export const GET_LEAD_NUM = 'dashboard/GET_LEAD_NUM'
export const GET_LEAD_NUM_CLICK = 'dashboard/GET_LEAD_NUM_CLICK'
export const GET_LEAD = 'dashboard/GET_LEAD'
export const SELECT_CHANGE = 'dashboard/SELECT_CHANGE'
export const GET_POPUP_LIST = 'dashboard/GET_POPUP_LIST'

// ファイルアップロード
export const REQUEST_FETCH_FILE = 'file/REQUEST_FETCH_FILE'
export const FINISH_FETCH_FILE = 'file/FINISH_FETCH_FILE'
export const REQUEST_FETCH_ALL_FILE = 'file/REQUEST_FETCH_ALL_FILE'
export const FINISH_FETCH_ALL_FILE = 'file/FINISH_FETCH_ALL_FILE'
export const REQUEST_CREATE_FILE = 'file/REQUEST_CREATE_FILE'
export const FINISH_CREATE_FILE = 'file/FINISH_CREATE_FILE'
export const REQUEST_UPDATE_FILE = 'file/REQUEST_UPDATE_FILE'
export const FINISH_UPDATE_FILE = 'file/FINISH_UPDATE_FILE'
export const REQUEST_DELETE_FILE = 'file/REQUEST_DELETE_FILE'
export const FINISH_DELETE_FILE = 'file/FINISH_DELETE_FILE'
export const UNLOAD_FILE = 'file/UNLOAD_FILE'
export const REQUEST_DOWNLOAD_FILE = 'file/REQUEST_DOWNLOAD_FILE'
export const FINISH_DOWNLOAD_FILE = 'file/FINISH_DOWNLOAD_FILE'
export const REQUEST_PREVIEW_FILE = 'file/REQUEST_PREVIEW_FILE'
export const FINISH_PREVIEW_FILE = 'file/FINISH_PREVIEW_FILE'
export const ERROR_FILE = 'file/ERROR_FILE'

// 投稿種別
export const REQUEST_FETCH_ALL_POST_TYPE =
  'post_type/REQUEST_FETCH_ALL_POST_TYPE'
export const FINISH_FETCH_ALL_POST_TYPE = 'post_type/FINISH_FETCH_ALL_POST_TYPE'
export const FAILURE_FETCH_ALL_POST_TYPE =
  'post_type/FAILURE_FETCH_ALL_POST_TYPE'
export const REQUEST_FETCH_POST_TYPE = 'post_type/REQUEST_FETCH_POST_TYPE'
export const FINISH_FETCH_POST_TYPE = 'post_type/FINISH_FETCH_POST_TYPE'
export const FAILURE_FETCH_POST_TYPE = 'post_type/FAILURE_FETCH_POST_TYPE'
export const REQUEST_CREATE_POST_TYPE = 'post_type/REQUEST_CREATE_POST_TYPE'
export const FINISH_CREATE_POST_TYPE = 'post_type/FINISH_CREATE_POST_TYPE'
export const FAILURE_CREATE_POST_TYPE = 'post_type/FAILURE_CREATE_POST_TYPE'
export const REQUEST_UPDATE_POST_TYPE = 'post_type/REQUEST_UPDATE_POST_TYPE'
export const FINISH_UPDATE_POST_TYPE = 'post_type/FINISH_UPDATE_POST_TYPE'
export const FAILURE_UPDATE_POST_TYPE = 'post_type/FAILURE_UPDATE_POST_TYPE'

// 権限
export const REQUEST_FETCH_ALL_PERMISSION =
  'permission/REQUEST_FETCH_ALL_PERMISSION'
export const FINISH_FETCH_ALL_PERMISSION =
  'permission/FINISH_FETCH_ALL_PERMISSION'
export const FAILURE_FETCH_ALL_PERMISSION =
  'permission/FAILURE_FETCH_ALL_PERMISSION'
